module.exports = __webpack_public_path__ + "img/icon-check-disabled.3f9dd38.svg";